import React from 'react'
import cx from 'classnames'

import {
  GrowFollowersEditorStep,
  LeadGenEditorStep,
  LeadQualEditorStep,
  StepState,
} from 'apps/aiAutomation/components/EngagementGoalEditor/lib/types'

import sharedCm from '../EditorLayout/EditorLayout.module.css'
import { StepIndicator } from '../StepIndicator/StepIndicator'

interface EditorStepLayoutProps<
  T extends GrowFollowersEditorStep | LeadGenEditorStep | LeadQualEditorStep,
> {
  number: number
  step: T
  stepsState: StepState<T>
  isDimmed: boolean
  children: React.ReactNode

  className?: string
  isBlocked?: boolean
}

export const EditorStepLayout = <
  T extends GrowFollowersEditorStep | LeadGenEditorStep | LeadQualEditorStep,
>({
  className,
  number,
  step,
  stepsState,
  children,
  isBlocked,
  isDimmed,
}: EditorStepLayoutProps<T>) => {
  const isCurrent = stepsState.current === step
  const isCompleted = stepsState.completed[step]

  return (
    <div className={cx('p-relative', className)}>
      <StepIndicator
        number={number}
        isCompleted={isCompleted}
        isCurrent={isCurrent}
        isBlocked={isBlocked}
        className={sharedCm.stepIndicator}
      />

      <div
        className={cx(isDimmed && sharedCm.section_disabled)}
        // @ts-expect-error type for inert is supported starting from React 19+
        // It's also not working for now when we pass true/false, that's why there is an empty string and undefined values
        inert={isDimmed ? '' : undefined}
      >
        {children}
      </div>
    </div>
  )
}
